import React, { FC } from 'react';

import { MobileVivaAppBarProps } from './MobileVivaAppBar';

const size = 40;

const MobileVivaAppBarPlaceholder: FC<MobileVivaAppBarProps> = () => <div style={{ width: size, height: size }} />;

export default MobileVivaAppBarPlaceholder;
